export const AdminConstants = {
    EXPORT_USERSLIST_SUCCESS: "Successfully exported the users list",
    EXPORT_USERSLIST_ERROR: "Failed to download user details",
    EXPORT_USERSLIST_NOTAVAILABLE: "User details are not available to export",
    EXPORT_USERSLIST_DOWNLOADERROR: "Download link or blob is not set",
    EXPORT_STORESLIST_SUCCESS: "Successfully exported the stores list",
    EXPORT_STORESLIST_ERROR: "Failed to download store details",
    EXPORT_STORESLIST_NOTAVAILABLE: "Store details are not available to export",
}